import { z } from 'zod';
import { ApplicationStage as Stage } from '../../graphql/operations';

export const applicationStageSchema = z.nativeEnum(Stage);

export type ApplicationStage = z.infer<typeof applicationStageSchema>;
